var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-field",
    {
      staticClass: "g-select",
      staticStyle: { "padding-right": "10px" },
      attrs: {
        error: _vm.$v.dValue.$error,
        "error-label": _vm.mensagemErro,
        disabled: _vm.desabilitar,
        helper: _vm.mensagemAjuda
      }
    },
    [
      _vm.multi
        ? _c("q-select", {
            attrs: {
              name: _vm.name,
              id: _vm.id,
              multiple: "",
              chips: "",
              separator: "",
              value: _vm.value,
              options: _vm.itensConvertidos,
              "float-label": _vm.etiqueta,
              disable: _vm.desabilitar,
              color: _vm.cor
            }
          })
        : _c("q-select", {
            attrs: {
              name: _vm.name,
              id: _vm.id,
              value: _vm.value,
              options: _vm.itensConvertidos,
              "float-label": _vm.etiqueta,
              disable: _vm.desabilitar,
              filter: "",
              "autofocus-filter": ""
            },
            on: {
              input: function($event) {
                _vm.atualizarModelo($event)
              },
              change: _vm.change
            }
          })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }